var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLinkDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.023,
    height: 16.91,
    viewBox: "0 0 19.023 16.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#455079;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.023.793V5.02a.793.793,0,0,1-1.353.56L16.491,4.4,8.448,12.443a.793.793,0,0,1-1.121,0L6.58,11.7a.793.793,0,0,1,0-1.121l8.043-8.043L13.444,1.353A.793.793,0,0,1,14,0h4.227A.793.793,0,0,1,19.023.793ZM13.443,8.943l-.528.528a.793.793,0,0,0-.232.56V14.8H2.114V4.227h8.719A.793.793,0,0,0,11.393,4l.528-.528a.793.793,0,0,0-.56-1.353H1.585A1.585,1.585,0,0,0,0,3.7V15.324A1.585,1.585,0,0,0,1.585,16.91H13.211A1.585,1.585,0,0,0,14.8,15.324V9.5A.793.793,0,0,0,13.443,8.943Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkDark);
export default __webpack_public_path__ + "static/media/external-link-dark.b77a61f3f2ba29a0ae5eac9eefed3ea6.svg";
export { ForwardRef as ReactComponent };